<div class="p-grid">
  <div class="p-col-2">
    <p-scrollpanel [style]="{width: '100%', height: '84vh'}">
      @if (calendarComponent) {
      <app-work-orders-panel [selectedView]='selectedView' [isTreeWorkOnly]="true" [canDrag]="canEdit"
        (taskDraggedStartEvent)="taskDragStart($event)" (taskDraggedEndEvent)="taskDragEnd()"
        (dragStartEvent)="woDragStart($event)" (dragEndEvent)="clearGrayOverlayOnBuckets()"></app-work-orders-panel>
      }
    </p-scrollpanel>
  </div>
  <div class="p-col-8">
    <p-scrollpanel [style]="{width: '100%', height: '84vh'}">
      <div style="height: 100%">
        <app-week-calendar-view (woDragged)="onWoDragged($event)" (woDraggedEnd)="onWoDraggedEnd()" [canDrag]="canEdit"
          (taskDragged)="taskDragStart($event)" (taskDraggedEnd)="taskDragEnd()" [isWork]="true"
          [isWellness]="false"></app-week-calendar-view>
      </div>
    </p-scrollpanel>
  </div>
  <div class="p-col-2">
    <p-scrollpanel [style]="{width: '100%', height: '84vh'}">
      <app-crews-and-equipment-panel [selectedView]='selectedView' [canDrag]="canEdit"></app-crews-and-equipment-panel>
    </p-scrollpanel>
  </div>
</div>